import React, { useState } from 'react';
import styled from 'styled-components';

interface ZoomableImageProps {
  src: string;
  alt: string;
  width?: string;
  height?: string;
}

const ImageContainer = styled.div`
  cursor: pointer;
`;

const ModalOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.7);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
  cursor: pointer;
`;

const ZoomedImage = styled.img`
  max-width: 90vw;
  max-height: 90vh;
  object-fit: contain;
`;

const StyledImage = styled.img<{ width?: string; height?: string }>`
  width: ${props => props.width || 'auto'};
  height: ${props => props.height || 'auto'};
  object-fit: contain;
`;



export const ZoomableImage: React.FC<ZoomableImageProps> = ({
  src,
  alt,
  width,
  height
}) => {
  const [isZoomed, setIsZoomed] = useState(false);

  const handleImageClick = () => {
    if (src && src.trim().length > 0) {
      setIsZoomed(true);
    }
  };

  const handleModalClick = () => {
    setIsZoomed(false);
  };

  return (
    <>
      <ImageContainer onClick={handleImageClick}>
        <img 
          src={src} 
          alt={alt} 
          style={{ width: width || 'auto', height: height || 'auto'}}
        />
      </ImageContainer>

      {isZoomed && (
        <ModalOverlay onClick={handleModalClick}>
          <ZoomedImage src={src} alt={alt} />
        </ModalOverlay>
      )}
    </>
  );
};